package component.product

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import feature.product.model.Product
import feature.productCategory.handler.ProductCategoryHandler
import feature.productCategory.model.ProductCategory
import feature.productCategory.viewModel.ProductCategoryViewModel

@Composable
fun ProductListForCategory(
    onClick: (ProductCategory) -> Unit,
    onClickProduct: (Product) -> Unit,
    viewModel: ProductCategoryViewModel
) {

    val products = ProductCategoryHandler.shared().repository.products.collectAsState()
    LaunchedEffect(key1 = Unit) {
        viewModel.selectedCategory.value?.let { viewModel.loadProducts(it) }
    }
    LazyVerticalGrid(
        columns = GridCells.Adaptive(minSize = 150.dp),
        modifier = Modifier
            .height(900.dp)
            .fillMaxWidth()
    ) {
        items(count = products.value.count()) { index ->
            ProductCard(product = products.value[index], onClick = onClickProduct)
        }
    }
}
